const statusKeys = {
    bookingEntered: {
        label: "Booking Entered",
        group: "booking",
    },
    bookingConfirmationSentToCustomer: {
        label: "Booking Confirmation Sent to Customer",
        group: "booking",
    },
    bookingConfirmedByCustomer: {
        label: "Booking Confirmed by Customer",
        group: "booking",
    },
    cad: {
        label: "CAD",
        group: "booking",
    },
    //trucking
    truckerDispatchSent: {
        label: "Trucker Dispatch Sent",
        group: "trucking",
    },
    truckerDispatchConfirmed: {
        label: "Trucker Dispatch Sent",
        group: "trucking",
    },
    loadingStatusTruckerConfirm: {
        label: "Trucker Dispatch Confirmed",
        group: "trucking",
    },
    railBillingRequestSent: {
        label: "Rail Billing Request Sent",
        group: "trucking",
    },
    loadLeftWarehouse: {
        label: "Load Left Warehouse",
        group: "trucking",
    },

    //


    //completion
    containerOnboard: {
        label: "Container Onboard",
        group: "completion",
    },
    confirmArrival: {
        label: "Confirm Arrival",
        group: "completion",
    },
    fileClosed: {
        label: "File Closed",
        group: "completion",
    },
    preAlertSentToAgent: {
        label: "Pre Alert Sent to Agent",
        group: "completion",
    },
    ics2Filed: {
        label: "ICS2 Filed",
        group: "completion",
    },
    //billing
    afrFiling: {
        label: "AFR Filing Complete",
        group: "billing",
    },
    aesFiling: {
        label: "AES Filing Complete",
        group: "billing",
    },
    readyToInvoice: {
        label: "Ready to Invoice",
        group: "billing",
    },
    invoiceCreated: {
        label: "Invoice Created",
        group: "billing",
    },
    invoiceHblSentToCustomer: {
        label: "Invoice Sent to Customer",
        group: "billing",
    },
    paymentReceivedFromCustomer: {
        label: "Payment Received from Customer",
        group: "billing",
    },
    //
    billPaymentStatus: {
        label: "Bill Payment Status",
        group: "billing",
    },

    wireTransferStatus: {
        label: "Wire Transfer Status",
        group: "billing",
    },


    railBillingConfirmed: {
        label: "Rail Billing Confirmed",
        group: "billing",
    },

    //documentation
    customHoldByCarrier: {
        label: "Custom Hold by Carrier",
        group: "documentation",
    },
    mblProofedApproved: {
        label: "MBL Proofed Approved",
        group: "documentation",
    },
    mblRevisionPending: {
        label: "MBL Revision Pending",
        group: "documentation",
    },
    masterBlSentToCarrier: {
        label: "Master B/L Checked and Sent to Carrier",
        group: "documentation",
    },
    hblSent: {
        label: "Sea Waybill / Express Release BL Sent to Customer",
        group: "documentation",
    },
    drainDisconnectStatementReceived: {
        label: "Drain and Disconnect Statement Received",
        group: "documentation",
    },
    drainDisconnectStatementSentToCarrier: {
        label: "Drain and Disconnect Statement Sent to Carrier",
        group: "documentation",
    },
    titleReceivedFromSsline: {
        label: "Title Received / Schedule Loading Confirmed from SSLinez",
        group: "documentation",
    },
    titleSentToSsline: {
        label: "Title Sent to SSLine",
        group: "documentation",
    },
    autoTitleCopiesReceivedFromCustomer: {
        label: "Auto Validated Title Copies Received from Customer",
        group: "documentation",
    },
    proofBlApprovedByCustomer: {
        label: "Proof B/L Approved by Customer",
        group: "documentation",
    },
    proofBlSentToCustomer: {
        label: "Proof B/L Sent to Customer",
        group: "documentation",
    },
    mblEntered: {
        label: "MBL Entered",
        group: "documentation",
    },
    docsReceivedFromCustomer: {
        label: "Docs Received from Customer",
        group: "documentation",
    },
    vgmSubmittedToCarrier: {
        label: "VGM Submitted to Carrier",
        group: "documentation",
    },
    vgmReceivedFromClient: {
        label: "VGM Received from Client",
        group: "documentation",
    },
    requestForShippingInstructionSent: {
        label: "Request for Shipping Instruction Sent",
        group: "documentation",
    },
    originalTitleReceived: {
        label: "Original Title Received for Validation",
        group: "documentation",
    },
    hblMblEntered: {
        label: "HBL Entered",
        group: "documentation",
    },
    originalHblTitlesSentToCustomer: {
        label: "Original HBL Sent to Customer",
        group: "documentation",
    },

    //



    carrierBlReceivedFromCarrier: {
        label: "Carrier BL Received from Carrier",
        group: "documentation",
    },

    telexReleaseFromCarrierSentToAgent: {
        label: "Telex Release Sent to Agent",
        group: "documentation",
    },

    preliminaryDummyBl: {
        label: "Preliminary / Dummy BL",
        group: "documentation",
    },

    receivedBlApprovalFromAgent: {
        label: "BL Approval Received from Agent",
        group: "documentation",
    },

    expressReleaseBlSentToCustomer: {
        label: "Express Release BL Sent to Customer",
        group: "documentation",
    },

    preAdviceSentToAgent: {
        label: "Pre-Advice Sent to Agent",
        group: "documentation",
    },
    receivedAtOrigin: {
        label: "Received at Origin",
        group: "documentation",
    },
};

export const mapStatusObject = (obj) => {
    const statusObject = [];

    Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === "boolean") {
            const value = obj[`${key}Dt`] || null;

            let date = "";
            let time = "";

            if (value) {
                const d = new Date(value);

                date = d.toISOString().split("T")[0];
                time = d.toISOString().split("T")[1].slice(0, 5);
            }

            const newObj = {
                checked: obj[key] || null,
                id: key,
                [`${key}Dt`]: obj[`${key}Dt`] || null,
                label: statusKeys[key]?.label || key,
                date: obj[key] === true ? date : "",
                time: obj[key] === true ? time : "",
                group: statusKeys[key]?.group || "General",
            };
            statusObject.push(newObj);
        }
    });

    return statusObject;
};

export const generatePayload = (data, prevData) => {
    const payload = { ...prevData };
    data.forEach((value) => {
        console.log(value);
        const key = value.id;
        const dateKey = `${key}Dt`;
        const dateKeyCurr = `${key}Dtcurrent`;
        payload[key] = value?.checked === true;
        payload[dateKey] = value?.checked
            ? `${value?.date}T${value?.time}:39.303Z`
            : `${value[dateKey]}Z`;

        payload[dateKeyCurr] = value?.checked
            ? `${value?.date}T${value?.time}:39.303Z`
            : `${value[dateKey]}Z`;
    });
    console.log("dateKey", getCurrentDateTime())
    return payload;
};

function getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(now.getDate()).padStart(2, '0');

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}
const time = getCurrentDateTime();
export const defaultData = {
    "id": 0,
    "bookingId": 0,
    "bookingConfirmationSentToCustomer": false,
    "bookingConfirmationSentToCustomerDt": time,
    "bookingConfirmationSentToCustomerBy": "string",
    "truckerDispatchSent": false,
    "truckerDispatchSentDt": time,
    "truckerDispatchSentBy": "string",
    "loadingStatusTruckerConfirm": false,
    "loadingStatusTruckerConfirmDt": time,
    "loadingStatusTruckerConfirmBy": "string",
    "railBillingRequestSent": false,
    "railBillingRequestSentDt": time,
    "railBillingRequestSentBy": "string",
    "railBillingConfirmed": false,
    "railBillingConfirmedDt": time,
    "railBillingConfirmedBy": "string",
    "customHoldByCarrier": false,
    "customHoldByCarrierDt": time,
    "customHoldByCarrierBy": "string",
    "originalTitleReceived": false,
    "originalTitleReceivedDt": time,
    "originalTitleReceivedBy": "string",
    "autoTitleCopiesReceivedFromCustomer": false,
    "autoTitleCopiesReceivedFromCustomerDt": time,
    "autoTitleCopiesReceivedFromCustomerBy": "string",
    "titleSentToSsline": false,
    "titleSentToSslineDt": time,
    "titleSentToSslineBy": "string",
    "titleReceivedFromSsline": false,
    "titleReceivedFromSslineDt": time,
    "titleReceivedFromSslineBy": "string",
    "requestForShippingInstructionSent": false,
    "requestForShippingInstructionSentDt": time,
    "requestForShippingInstructionSentBy": "string",
    "docsReceivedFromCustomer": false,
    "docsReceivedFromCustomerDt": time,
    "docsReceivedFromCustomerBy": "string",
    "hblMblEntered": false,
    "hblMblEnteredDt": time,
    "hblMblEnteredBy": "string",
    "proofBlSentToCustomer": false,
    "proofBlSentToCustomerDt": time,
    "proofBlSentToCustomerBy": "string",
    "masterBlSentToCarrier": false,
    "masterBlSentToCarrierDt": time,
    "masterBlSentToCarrierBy": "string",
    "containerOnboard": false,
    "containerOnboardDt": time,
    "containerOnboardBy": "string",
    "invoiceHblSentToCustomer": false,
    "invoiceHblSentToCustomerDt": time,
    "invoiceHblSentToCustomerBy": "string",
    "carrierBlReceivedFromCarrier": false,
    "carrierBlReceivedFromCarrierDt": time,
    "carrierBlReceivedFromCarrierBy": "string",
    "preAlertSentToAgent": false,
    "preAlertSentToAgentDt": time,
    "preAlertSentToAgentBy": "string",
    "paymentReceivedFromCustomer": false,
    "paymentReceivedFromCustomerDt": time,
    "paymentReceivedFromCustomerBy": "string",
    "originalHblTitlesSentToCustomer": false,
    "originalHblTitlesSentToCustomerDt": time,
    "originalHblTitlesSentToCustomerBy": "string",
    "telexReleaseFromCarrierSentToAgent": false,
    "telexReleaseFromCarrierSentToAgentDt": time,
    "telexReleaseFromCarrierSentToAgentBy": "string",
    "billPaymentStatus": false,
    "billPaymentStatusDt": time,
    "billPaymentStatusBy": "string",
    "wireTransferStatus": false,
    "wireTransferStatusDt": time,
    "wireTransferStatusBy": "string",
    "preliminaryDummyBl": false,
    "preliminaryDummyBlDt": time,
    "preliminaryDummyBlBy": "string",
    "fileClosed": false,
    "fileClosedDt": time,
    "fileClosedBy": "string",
    "confirmArrival": false,
    "confirmArrivalDt": time,
    "confirmArrivalBy": "string",
    "aesFiling": false,
    "aesFilingDt": time,
    "aesFilingBy": "string",
    "cad": false,
    "cadDt": time,
    "cadBy": "string",
    "hblSent": false,
    "hblSentDt": time,
    "hblSentBy": "string",
    "drainDisconnectStatementReceived": false,
    "drainDisconnectStatementReceivedDt": time,
    "drainDisconnectStatementReceivedBy": "string",
    "drainDisconnectStatementSentToCarrier": false,
    "drainDisconnectStatementSentToCarrierDt": time,
    "drainDisconnectStatementSentToCarrierBy": "string",
    "vgmReceivedFromClient": false,
    "vgmReceivedFromClientDt": time,
    "vgmReceivedFromClientBy": "string",
    "vgmSubmittedToCarrier": false,
    "vgmSubmittedToCarrierDt": time,
    "vgmSubmittedToCarrierBy": "string",
    "preAdviceSentToAgent": false,
    "preAdviceSentToAgentDt": time,
    "preAdviceSentToAgentBy": "string",
    "mblRevisionPending": false,
    "mblRevisionPendingDt": time,
    "mblRevisionPendingBy": "string",
    "mblProofedApproved": false,
    "mblProofedApprovedDt": time,
    "mblProofedApprovedBy": "string",
    "receivedBlApprovalFromAgent": false,
    "receivedBlApprovalFromAgentDt": time,
    "receivedBlApprovalFromAgentBy": "string",
    "bookingConfirmationSentToCustomerDtcurrent": time,
    "truckerDispatchSentDtcurrent": time,
    "loadingStatusTruckerConfirmDtcurrent": time,
    "railBillingRequestSentDtcurrent": time,
    "railBillingConfirmedDtcurrent": time,
    "customHoldByCarrierDtcurrent": time,
    "originalTitleReceivedDtcurrent": time,
    "autoTitleCopiesReceivedFromCustomerDtcurrent": time,
    "titleSentToSslineDtcurrent": time,
    "titleReceivedFromSslineDtcurrent": time,
    "requestForShippingInstructionSentDtcurrent": time,
    "docsReceivedFromCustomerDtcurrent": time,
    "hblMblEnteredDtcurrent": time,
    "proofBlSentToCustomerDtcurrent": time,
    "masterBlSentToCarrierDtcurrent": time,
    "containerOnboardDtcurrent": time,
    "invoiceHblSentToCustomerDtcurrent": time,
    "carrierBlReceivedFromCarrierDtcurrent": time,
    "preAlertSentToAgentDtcurrent": time,
    "paymentReceivedFromCustomerDtcurrent": time,
    "originalHblTitlesSentToCustomerDtcurrent": time,
    "telexReleaseFromCarrierSentToAgentDtcurrent": time,
    "billPaymentStatusDtcurrent": time,
    "wireTransferStatusDtcurrent": time,
    "preliminaryDummyBlDtcurrent": time,
    "fileClosedDtcurrent": time,
    "confirmArrivalDtcurrent": time,
    "aesFilingDtcurrent": time,
    "cadDtcurrent": time,
    "hblSentDtcurrent": time,
    "drainDisconnectStatementReceivedDtcurrent": time,
    "drainDisconnectStatementSentToCarrierDtcurrent": time,
    "vgmReceivedFromClientDtcurrent": time,
    "vgmSubmittedToCarrierDtcurrent": time,
    "preAdviceSentToAgentDtcurrent": time,
    "mblRevisionPendingDtcurrent": time,
    "mblProofedApprovedDtcurrent": time,
    "receivedBlApprovalFromAgentDtcurrent": time,
    "invoiceCreated": false,
    "invoiceCreatedDt": time,
    "invoiceCreatedBy": "string",
    "invoiceCreatedDtcurrent": time,
    "revisionNotes": "string",
    "revisionNotesBy": "string",
    "lastUpdatedStatus": "string",
    "modifiedBy": "string",
    "modifiedOn": "2026-02-10T09:10:28.907",
    "loadLeftWarehouse": false,
    "loadLeftWarehouseDt": time,
    "loadLeftWarehouseBy": "string",
    "loadLeftWarehouseDtcurrent": time,
    "proofBlApprovedByCustomer": false,
    "proofBlApprovedByCustomerDt": time,
    "proofBlApprovedByCustomerBy": "string",
    "proofBlApprovedByCustomerDtcurrent": time,
    "truckerDispatchConfirmed": false,
    "truckerDispatchConfirmedDt": time,
    "truckerDispatchConfirmedBy": "string",
    "truckerDispatchConfirmedDtcurrent": time,
    "receivedAtOrigin": false,
    "receivedAtOriginDt": time,
    "receivedAtOriginBy": "string",
    "receivedAtOriginDtcurrent": time,
    "afrFiling": false,
    "afrFilingDt": time,
    "afrFilingBy": "string",
    "afrFilingDtcurrent": time,
    "bookingConfirmedByCustomer": false,
    "bookingConfirmedByCustomerDt": time,
    "bookingConfirmedByCustomerBy": "string",
    "bookingConfirmedByCustomerDtcurrent": time,
    "mblEntered": false,
    "mblEnteredDt": time,
    "mblEnteredBy": "string",
    "mblEnteredDtcurrent": time,
    "expressReleaseBlSentToCustomer": false,
    "expressReleaseBlSentToCustomerDt": time,
    "expressReleaseBlSentToCustomerBy": "string",
    "expressReleaseBlSentToCustomerDtcurrent": time,
    "cobRemarks": "string",
    "mblProofingRemarks": "string",
    "readyToInvoice": false,
    "readyToInvoiceDt": time,
    "readyToInvoiceBy": "string",
    "readyToInvoiceDtcurrent": time,
    "ics2Filed": false,
    "ics2FiledDt": time,
    "ics2FiledBy": "string",
    "ics2FiledDtcurrent": time
}



